var exports = {
  "SG": "Okey101Melds.module__melds___Vm9laE",
  "Ie": "Okey101Melds.module__empty___Vm9laE",
  "jg": "Okey101Melds.module__meld___Vm9laE",
  "os": "Okey101Melds.module__tiles___Vm9laE",
  "qy": "Okey101Melds.module__ghost___Vm9laE",
  "jp": "Okey101Melds.module__badges___Vm9laE",
  "qS": "Okey101Melds.module__badge___Vm9laE",
  "so": "Okey101Melds.module__scores___Vm9laE",
  "pG": "Okey101Melds.module__caption___Vm9laE",
  "Kv": "Okey101Melds.module__scoreName___Vm9laE",
  "kE": "Okey101Melds.module__scoreValue___Vm9laE",
};

module.exports = exports;
